export default __webpack_public_path__ + "static/media/Victoria-Trustee.d94a42ca.jpg";